const dtpList = [];

$(document).ready(() => {
  $('.initDateTimePicker').each(function () {
    const elm = $(this);
    $(this).addClass('stopPropagation');
    dtpList.push(elm);

    const options = {
      allowInputToggle: true,
      locale: window.hlocale || 'ja',
    };

    if ($(elm).data('dtp-position-vertical')) {
      options.widgetPositioning = {};
      options.widgetPositioning.vertical = $(elm).data('dtp-position-vertical');
    }
    if ($(elm).data('dtp-format')) {
      options.format = $(elm).data('dtp-format');
    }

    elm.datetimepicker(options);

    elm.children('.input-group-addon')[0].addEventListener('click', () => {
      dtpList.forEach((dtp) => {
        if (dtp !== elm) {
          dtp.data('DateTimePicker').hide();
        }
      });
    });

    const closeModal = elm.data('close-modal');
    if (closeModal) {
      $(document).on('click', `#${closeModal} .modalInner`, () => {
        elm.data('DateTimePicker').hide();
      });
    }
  });
});
